import SiatPraticheSceltaListPage from "./pages/SiatPraticheSceltaListPage.vue";
import SiatPraticheAssegnateListPage from "./pages/SiatPraticheAssegnateListPage.vue";

export default {
	SiatPraticheSceltaListPage,
	SiatPraticheAssegnateListPage,
};
